/**
 * Возврат к началу экрана после смены шага.
 *
 * Маршрутизатор возвращает страницу наверх только при смене адреса, а мастер
 * онбординга меняет шаги внутри одного адреса. Второй шаг длиннее первого, шаг
 * «готово» — короче обоих, и после подтверждения человек оказывался посреди
 * пустоты: заголовок и строка «Шаг 2 из 2» оставались выше края окна, а на
 * экране висели три кнопки без объяснения, к чему они.
 *
 * Отсюда правило: **смена шага возвращает к началу экрана**. Не к началу
 * документа — к началу содержимого, потому что верхняя полоса липкая и своё
 * место занимает в любом положении.
 *
 * Плавность спрашивается у системы: `prefers-reduced-motion` включают не для
 * красоты, а потому что от движения укачивает.
 */

import { useEffect } from 'react';

export function useScrollToTop(key: unknown): void {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Первый кадр экран уже стоит наверху — дёргать его нечем и незачем.
    if (window.scrollY === 0) return;

    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: still ? 'auto' : 'smooth' });
  }, [key]);
}
